import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion';
import { Container, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';
import ProfileService from "../services/Profile";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";

const PointsEarned = () => {
    const navigate = useNavigate();
    const [isPointStatementData, setIsPointStatementData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const MyPointsDataFetch = async () => {
            try {
                const MyPointsResponse = await ProfileService.getAvailablePointsearned()

                if (MyPointsResponse.success == true) {
                    setIsPointStatementData(MyPointsResponse.response.pointDetails.month_wise_transc_list)
                    setLoading(false)
                }
            }
            catch (error) {
                console.error("Points Earning")

            }

        }
        MyPointsDataFetch()
    }, [])

    function viewDetailsHandler(month) {
        navigate(`/points-earned-details/${month}/${new Date().getFullYear()}`)
    }
    

    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Points Earned "
                currentPageName="Points Earned"
            />
            <section className='padTop50'>
                <Container>
                    <Row>
                        {isPointStatementData?.map((monthData, index) => {
                            return Object.keys(monthData).map((monthName,index) => (
                                <Col xs={12} key={index}>
                                    <Accordion defaultActiveKey="0" className="mb-3">
                                        <Accordion.Item eventKey={index} key={index}>
                                            <Accordion.Header>
                                                <div className="col-6">
                                                    <b className="text-primary">{monthName}</b>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <Table striped bordered hover>
                                                    <tbody>
                                                        <tr>
                                                            <td>Tier</td>
                                                            <td>{monthData[monthName].tier_name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Quantity(MTt)</td>
                                                            <td>{monthData[monthName].quantity}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Opening Balance</td>
                                                            <td>{monthData[monthName].opening_balance}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Base Point</td>
                                                            <td>{monthData[monthName].base_point}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bonus Point</td>
                                                            <td>{monthData[monthName].bonus_points}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Redeem Points</td>
                                                            <td>{monthData[monthName].redeem_points}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Expired Points</td>
                                                            <td>{monthData[monthName].expired_points}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Monthly Points</td>
                                                            <td>{monthData[monthName].monthly_points}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Closing Points</td>
                                                            <td>{monthData[monthName].closing_points}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <div className="vw-link ">
                                                    <a onClick={() => viewDetailsHandler(monthName, )}>View details</a>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Col>
                            ));
                        })}

                    </Row>

                </Container>
            </section>

        </>
    );
}

export default PointsEarned;
